import { svc_search } from "@/services";
import { message } from "antd";
import "lodash";
import logger from "@/utils/logger";

const endpointBasePrefix = "transactionitems";


const Model = {
	namespace: "m_TransactionItems",
	state: {
		transactionitems: [],
	},
	reducers: {
		handleFetchAll(state, { payload: { transactionitems } }) {
			logger(`** TransactionItems reducers response ${JSON.stringify(transactionitems)}`, 5);
			return { ...state, transactionitems };
		},
	},
	effects: {
		*fetchAll({ transaction_id }, { call, put }) {
			let payload = {
				transaction_id
			};
			// console.log("*********************** payload: ", payload)
			let transactionitems = yield call(svc_search, endpointBasePrefix, payload);
			_.forEach(transactionitems, function (row) {
				row.key = row.id;
			});
			// console.log("*********************** transactionitems: ", transactionitems)
			yield put({
				type: "handleFetchAll",
				payload: { transactionitems },
			});
		}
	},
	subscriptions: {
		setup({ dispatch, history }) {
			return history.listen(({ pathname, query }) => {
				if (pathname === "/salesdata/daily_sales") {
					dispatch({ type: "fetch", payload: query });
				}
			});
		},
	},
};

export default Model;
